export default {
  feedback: {
    usage_threshold: 'Minimumsbeløb for kurven for denne kampagne er (ekskl. leveringsgebyr)',
    promo_code_added: 'Rabatkode anvendt',
    promo_code_removed: 'Rabatkode {{code}} fjernet',
  },
};
